import { render, staticRenderFns } from "./BasicsMeasuringunit.vue?vue&type=template&id=8434ced6&scoped=true"
import script from "./BasicsMeasuringunit.vue?vue&type=script&lang=js"
export * from "./BasicsMeasuringunit.vue?vue&type=script&lang=js"
import style0 from "./BasicsMeasuringunit.vue?vue&type=style&index=0&id=8434ced6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8434ced6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8434ced6')) {
      api.createRecord('8434ced6', component.options)
    } else {
      api.reload('8434ced6', component.options)
    }
    module.hot.accept("./BasicsMeasuringunit.vue?vue&type=template&id=8434ced6&scoped=true", function () {
      api.rerender('8434ced6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsMeasuringunit/BasicsMeasuringunit.vue"
export default component.exports